import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

/**
 * Admin section layout — guarded by requirePermissionGuard so
 * unauthorised navigations are rejected before the route even
 * renders. The component lives in the .lazy.tsx sibling and is
 * code-split for smaller non-admin bundles.
 */
export const Route = createFileRoute("/dashboard/admin")({
  beforeLoad: requirePermissionGuard("admin.panel.access"),
});
